// THE YEARS THE FILTER OFFERS — the Requisition Lists run, to the year: ten of
// them, newest first, one ahead of today (features/requisition-lists/component/
// ToolBarActions/YearSelect.jsx). The two screens ask the same question and
// must not answer it with two different lists.
const CURRENT_YEAR = new Date().getFullYear();
const YEARS_COUNT = 10;
const FUTURE_YEARS_COUNT = 1;

export const DEFAULT_YEAR = CURRENT_YEAR;

export const YEAR_OPTIONS = [...Array(YEARS_COUNT)].map((element, index) => {
  const year = CURRENT_YEAR - index + FUTURE_YEARS_COUNT;
  return { key: index, value: year, text: String(year) };
});
